import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";
import {getAllProgramModules, getProgramBlocks} from "./actions";

function deleteBlockRequest() {
  return {
    type: types.DELETE_BLOCK_PROGRAM_REQUEST,
    fetchingDeleteProgramBlock: true
  };
}

function deleteBlockCompleted(deletedProgramBlock) {
  return {
    type: types.DELETE_BLOCK_PROGRAM_COMPLETED,
    fetchingDeleteProgramBlock: false,
    deletedProgramBlock
  };
}

function deleteBlockError(fetchingDeleteProgramBlockError) {
  return {
    type: types.DELETE_BLOCK_PROGRAM_ERROR,
    fetchingDeleteProgramBlock: false,
    fetchingDeleteProgramBlockError
  };
}

export function deleteProgramBlock(id, blockId) {

  return dispatch => {
    dispatch(deleteBlockRequest());
    return api.deleteBlock(id, blockId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteBlockCompleted(response.data));
          dispatch(getProgramBlocks(id));
          logSuccess("Блок успешно удалён")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(deleteBlockError(message));
        } else {
          logError(err);
          dispatch(deleteBlockError(createError("Не удалось удалить программный блок")));
        }
      });
  };
}

function deleteModuleRequest() {
  return {
    type: types.REMOVE_MODULE_PROGRAM_REQUEST,
    fetchingDeleteProgramModule: true
  };
}

function deleteModuleCompleted(deletedProgramModule) {
  return {
    type: types.REMOVE_MODULE_PROGRAM_COMPLETED,
    fetchingDeleteProgramModule: false,
    deletedProgramModule
  };
}

function deleteModuleError(fetchingDeleteProgramModuleError) {
  return {
    type: types.REMOVE_MODULE_PROGRAM_ERROR,
    fetchingDeleteProgramModule: false,
    fetchingDeleteProgramModuleError
  };
}

export function excludeProgramModule(id, moduleId) {

  return dispatch => {
    dispatch(deleteModuleRequest());
    return api.excludeModule(id, moduleId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleCompleted(response.data));
          dispatch(getAllProgramModules(id));
          logSuccess("Модуль успешно исключен")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(deleteModuleError(message));
        } else {
          logError(err);
          dispatch(deleteModuleError(createError("Не удалось удалить программный модуль")));
        }
      });
  };
}

export default {
  deleteProgramBlock,
  excludeProgramModule
}
